/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeSelect } from '@base/react';
import React from 'react';
import { WrapperFields, WrapperFieldsGroup } from './basic-data-styled';

// import { Container } from './styles';

function SubformStartup({
  year,
  handleYearChange,
  handleMsgValidateYear,
  formValidation,
  setOptionToYear,
  optionToYear,
  handleMsgValidateOptionToYear,
}) {
  const anoAtual = new Date().getFullYear();
  const anos = [];

  for (let ano = anoAtual; ano >= 1988; ano--) {
    anos.push({ id: ano - 1987, label: ano.toString() });
  }

  return (
    <WrapperFields>
      <hr style={{ width: '90%', border: '1px solid #cecece' }} />
      <WrapperFieldsGroup>
        <BaSeSelect
          selectedValueId={optionToYear.id}
          label="Já participou de algum seminário Empretec?"
          width="100%"
          values={[
            { id: 1, label: 'Sim' },
            { id: 2, label: 'Não' },
          ]}
          onChange={(e) => {
            setOptionToYear(e);
          }}
          complement={formValidation && handleMsgValidateYear()}
        />
      </WrapperFieldsGroup>

      {optionToYear.id === 1 && (
        <WrapperFieldsGroup>
          <BaSeSelect
            label="Em que ano?"
            width="50%"
            values={anos}
            selectedValueId={year.id}
            onChange={handleYearChange}
            complement={formValidation && handleMsgValidateOptionToYear()}
          />
        </WrapperFieldsGroup>
      )}
    </WrapperFields>
  );
}

export default SubformStartup;
